const Urls = {
  home: { path: '/', exact: true },
  virtualGallery: {
    root: { path: '/virtual-gallery', exact: true },
    entrance: { path: '/virtual-gallery/entrance' },
    mainRoom: { path: '/virtual-gallery/main-room' },
    corridor: { path: '/virtual-gallery/corridor' },
    smallRoom: { path: '/virtual-gallery/small-room' },
  },
  AutoShowroom: {
    root: { path: '/auto-showroom', exact: true },
    c4BackCar: { path: '/auto-showroom/c4BackCar' },
    frontCar: { path: '/auto-showroom/frontCar' },
    incCar: { path: '/auto-showroom/inCar' },
    frontEntrance: { path: '/auto-showroom/frontEntrance' },
    lounge: { path: '/auto-showroom/lounge' },
  },
  winemakersCut: {
    root: { path: '/winemakers-cut', exact: true },
    seat1: { path: '/winemakers-cut/seat1' },
    seat2: { path: '/winemakers-cut/seat2' },
    bohemianWines: { path: '/winemakers-cut/bohemian' },
    cutWines: { path: '/winemakers-cut/cut' },
    sparklingWines: { path: '/winemakers-cut/spark' },
    bohoWines: { path: '/winemakers-cut/boho' },
  },
  realEstate: {
    root: { path: '/real-estate', exact: true },
    office: { path: '/real-estate/office' },
    bathroom: { path: '/real-estate/bathroom' },
    bedroomView: { path: '/real-estate/bedroom-view' },
    kitchen: { path: '/real-estate/kitchen' },
    outdoorBackView: { path: '/real-estate/outdoor-back-view' },
    outdoorView: { path: '/real-estate/outdoor-view' },
  },
  emptyShowroom: {
    root: { path: '/empty-showroom', exact: true },
    entrance: { path: '/empty-showroom/entrance' },
    view: { path: '/empty-showroom/view' },
  },
  campionBoatRoom: {
    root: { path: '/campionboat-room', exact: true },
    frontCounter: { path: '/campionboat-room/front-counter' },
    backBody: { path: '/campionboat-room/back-body' },
    body: { path: '/campionboat-room/body' },
    frontBody: { path: '/campionboat-room/frontbody' },
  },
  musicStudio: {
    root: { path: '/music-studio', exact: true },
    mac: { path: '/music-studio/mac' },
    piano: { path: '/music-studio/piano' },
    recording: { path: '/music-studio/recording' },
    shelves: { path: '/music-studio/shelves' },
    tshirt: { path: '/music-studio/tshirt' },
    keyboard: { path: '/music-studio/keyboard' },
  },
  lockerRoom: {
    root: { path: '/sports', exact: true },
    lockerRoom1: { path: '/sports/locker-room1' },
    lockerRoom2: { path: '/sports/locker-room2' },
    lockerRoom3: { path: '/sports/locker-room3' },
  },
  auto2: {
    root: { path: '/auto2', exact: true },
    frame1: { path: '/auto2/frame1' },
    frame2: { path: '/auto2/frame2' },
  },
  jamesHouse: {
    root: { path: '/james-house', exact: true },
    bath1: { path: '/james-house/bath1' },
    bath2: { path: '/james-house/bath2' },
    bedroom1: { path: '/james-house/bedroom1' },
    bedroom2: { path: '/james-house/bedroom2' },
    entrance: { path: '/james-house/entrance' },
    kitchen: { path: '/james-house/kitchen' },
    living: { path: '/james-house/living' },
  },
  arcade: {
    root: { path: '/arcade', exact: true },
    C1: { path: '/arcade/C1' },
    C2: { path: '/arcade/C2' },
    C3: { path: '/arcade/C3' },
    C4: { path: '/arcade/C4' },
    C5: { path: '/arcade/C5' },
    C6: { path: '/arcade/C6' },
    C7: { path: '/arcade/C7' },
    C8: { path: '/arcade/C8' },
    C9: { path: '/arcade/C9' },
  },
northWind: {
    root: { path: '/north-wind', exact: true },
    c1: {path: '/north-wind/c1'},
    c2: {path: '/north-wind/c2'},
    m01: {path: '/north-wind/m01'},
    m02: {path: '/north-wind/m02'},
    m03: {path: '/north-wind/m03'},
    m04: {path: '/north-wind/m04'},
    m05: {path: '/north-wind/m05'},
    m06: {path: '/north-wind/m06'},
    m07: {path: '/north-wind/m07'},
    m08: {path: '/north-wind/m08'},
    purpleDude: {path: '/north-wind/purple-dude'},
    m09: {path: '/north-wind/m09'},
    m10: {path: '/north-wind/m10'},
    m11: {path: '/north-wind/m11'},
    m12: {path: '/north-wind/m12'},
    m13: {path: '/north-wind/m13'},
    m14: {path: '/north-wind/m14'},
    m15: {path: '/north-wind/m15'},
    perspective: {path: '/north-wind/perspective'},
    m16: {path: '/north-wind/m16'},
    m17: {path: '/north-wind/m17'},
    m18: {path: '/north-wind/m18'},
    m19: {path: '/north-wind/m19'},
    m20: {path: '/north-wind/m20'},
    m21: {path: '/north-wind/m21'},
    m22: {path: '/north-wind/m22'},
    m23: {path: '/north-wind/m23'},
    familyTime: {path: '/north-wind/family-time'},
    flowersTote: {path: '/north-wind/flowers-tote'},
    md01: {path: '/north-wind/md01'},
    md02: {path: '/north-wind/md02'},
    md03: {path: '/north-wind/md03'},
    md04: {path: '/north-wind/md04'},
    md05: {path: '/north-wind/md05'},
    md06: {path: '/north-wind/md06'},
    md07: {path: '/north-wind/md07'},
  },
  stlBlues:{
    root: { path: '/stl-blues', exact: true },
    view1: {path: '/stl-blues/view1'},
    view3: {path: '/stl-blues/view3'},
    view4: {path: '/stl-blues/view4'},
    view5: {path: '/stl-blues/view5'},
    view6: {path: '/stl-blues/view6'},
    view7: {path: '/stl-blues/view7'},
    view8: {path: '/stl-blues/view8'},
    view10: {path: '/stl-blues/view10'},
    view11: {path: '/stl-blues/view11'},
    view12: {path: '/stl-blues/view12'},
    view13: {path: '/stl-blues/view13'},
    view14: {path: '/stl-blues/view14'},
  },
  ivyShop: {
    root: {path: '/ivyshop', exact: true},
    outsideEntrance: {path: '/ivyshop/outside-entrance'},
    outsideCenter: {path: '/ivyshop/outside-center'},
    outsideLeft: {path: '/ivyshop/outside-left'},
    outsideRight: {path: '/ivyshop/outside-right'},
    entrance: {path: '/ivyshop/entrance'},
    entranceDisplay: {path: '/ivyshop/entrance-display'},
    exitDisplay: {path: '/ivyshop/exit-display'},
    center: {path: '/ivyshop/center'},
    hayBales: {path: '/ivyshop/hay-bales'},
    exit: {path: '/ivyshop/exit'},
    corner: {path: '/ivyshop/corner'},
    stairs: {path: '/ivyshop/stairs'},
    upstairsEntrance: {path: '/ivyshop/upstairs-entrance'},
    upstairsCenter: {path: '/ivyshop/upstairs-center'},
    upstairsDisplay: {path: '/ivyshop/upstairs-display'},
  }
}

export default Urls;


